<template>
  <span>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col>
          <!-- Menu de selection du référentiel -->
          <b-card title="Gestion des referentiels">
            <b-tabs card>
              <b-tab
                active
                title="Catégorie dépense"
                @click="
                  currentType = typeReferentiel.categorieDepense;
                  resetForm();
                "
              >
              </b-tab>
              <b-tab
                title="Catégorie recette"
                @click="
                  currentType = typeReferentiel.categorieRecette;
                  resetForm();
                "
              >
              </b-tab>
              <b-tab
                title="Devises"
                @click="
                  currentType = typeReferentiel.devise;
                  resetForm();
                "
              >
              </b-tab>
              <b-tab
                title="Mode de paiement"
                @click="
                  currentType = typeReferentiel.modePaiement;
                  resetForm();
                "
              >
              </b-tab>
            </b-tabs>

            <b-form @submit.prevent="onSubmit">
              <collapse-card :creation-modification="selectedReferentiel.id">
                <b-row>
                  <b-col>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('libelle')"
                      label="Libelle"
                      label-for="libelle"
                      required
                    >
                      <div
                        v-if="!selectedReferentiel.modifiable"
                        class="text-danger font-weight-light"
                      >
                        Pour des besoins métier, ce libelle ne peut être changé
                      </div>
                      <b-form-input
                        id="libelle"
                        v-model="selectedReferentiel.libelle"
                        v-validate="'required|max:40'"
                        :disabled="!selectedReferentiel.modifiable"
                        :state="veeErrors.has('libelle') ? false : null"
                        name="libelle"
                        type="text"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('inputCommentaire')"
                      label="Commentaire"
                      label-for="inputCommentaire"
                      required
                    >
                      <b-form-textarea
                        id="inputCommentaire"
                        v-model="selectedReferentiel.commentaire"
                        v-validate="'max:200'"
                        :rows="3"
                        :state="
                          veeErrors.has('inputCommentaire') ? false : null
                        "
                        name="inputCommentaire"
                        type="text"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-button
                      class="m-1 float-right"
                      type="submit"
                      variant="primary"
                      >Enregistrer
                    </b-button>
                    <b-button
                      class="m-1 float-right"
                      variant="danger"
                      @click="resetForm()"
                    >
                      Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </collapse-card>
            </b-form>

            <custom-tab
              :customFilter="currentType"
              :tableData="referentiels"
              :tableFields="tableFields"
              libelleSuppressionProperty="libelle"
              messageSuppression="Confirmez-vous la suppression du référentiel"
              @deleteConfirmed="deleteReferentiel"
              @editSelected="onSelectEditReferentiel"
            ></custom-tab>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </span>
</template>

<script>
import ToastService from "../service/toastService";
import ApiService from "../service/apiService";
import CollapseCard from "../components/CollapseCard";
import CustomTab from "../components/CustomTab";

//Je met ça ici pour épurer l'attribut data
var tableColumns = [
  {
    key: "libelleNonModifiable",
    label: "Libelle",
    sortable: true,
  },
  {
    key: "commentaire",
    label: "Commentaire",
    sortable: true,
  },
  {
    key: "Actions",
    label: "",
  },
];

/**
 * Identifiant pour identifier le type de réferentiel en cours d'édition
 */

export default {
  name: "referentiels",
  components: {
    CollapseCard,
    CustomTab,
  },
  data() {
    return {
      //Tableau des réferentiels récupérés du serveur
      referentiels: [],
      //Objet des types de referentiels récupérés du serveur à l'init
      typeReferentiel: {
        categorieDepense: "",
        categorieRecette: "",
        modePaiement: "",
        devise: "",
      },
      //Réferentiel sélectionné, utilisé pour passer le reférentiel lors de la suppression
      selectedReferentiel: {
        modifiable: true,
      },

      //Champs qu'affichera le tableau des utilisateurs
      tableFields: tableColumns,

      //Type des referentiels actuel, il est mis à jours avec les onglets
      currentType: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Action aprés la validation du formulaire de creation/modification de referentiel
     */
    onSubmit() {
      var vm = this;
      //On vérifie les champs
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.selectedReferentiel.referentielsType = this.currentType;
          ApiService.referentiels
            .createOrUpdateReferentiels(this.selectedReferentiel)
            .then((resp) => {
              ToastService.displaySuccessToast(resp.data.message);
              this.resetForm();
              //On recharge les reférentiels pour les actualiser
              this.findAllReferentiels();
            });
        }
      });
    },
    /**
     * Méthode appelé aprés la montage du composant
     */
    init() {
      this.findAllReferentiels();
      this.findReferentielsType();
    },
    /**
     * Charge tous les réferentiels
     */
    findAllReferentiels() {
      ApiService.referentiels.findReferentiels().then((resp) => {
        this.referentiels = resp.data;
      });
    },
    findReferentielsType() {
      ApiService.referentiels.findReferentielsTypes().then((resp) => {
        this.typeReferentiel = resp.data;
        //Par défaut le page est initialisé avec le type de référentiel à catégorie dépense
        this.currentType = this.typeReferentiel.categorieDepense;
      });
    },
    /**
     * Envoi la requete de suppression d'un referentiels, ferme la modal et retire l'utilisateur selectionné des utilisateurs de la page
     */
    deleteReferentiel(referentiel) {
      ApiService.referentiels.deleteReferentiel(referentiel).then((resp) => {
        ToastService.displaySuccessToast(resp.data.message);

        //On recharge les reférentiels pour les actualiser
        this.findAllReferentiels();
      });
    },

    /**
     * Action lorsqu'on clique sur l'icone pour modifier un référentiel
     */
    onSelectEditReferentiel(item) {
      //On vide d'abord l'existant
      this.resetForm();
      //On copie les attributs de l'objet item
      this.selectedReferentiel = Object.assign(this.selectedReferentiel, item);
    },

    /**
     * Réinitialise le formulaire
     */
    resetForm() {
      this.selectedReferentiel = {};
      this.selectedReferentiel.modifiable = true;
      this.$validator.reset();
    },
  },
};
</script>
